import { memo } from 'react';
import PropTypes from 'prop-types';

import { When } from 'react-if';

import './Header.scss';

const Header = ({ expanded, animationStarted, onDotClick, text }) => (
  <div className="sidebar__group__header">
    <div 
        className="sidebar__group__header__icon"
        onClick={onDotClick}
    >
      <div className="sidebar__group__header__icon__dot"/>
      <div className="sidebar__group__header__icon__dot"/>
      <div className="sidebar__group__header__icon__dot"/>
    </div>
    <When condition={expanded && !animationStarted}>
      {() => (
        <div className="sidebar__group__header__text">
          {text}
        </div>
      )}
    </When>
  </div>
)

Header.propTypes = {
  animationStarted: PropTypes.bool.isRequired,
  expanded: PropTypes.bool.isRequired,
  onDotClick: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired
}

export default memo(Header)